import { faSpinner } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const Loading = () => {
  return (
    <div className="flex w-full justify-center items-center content-center py-5">
      <FontAwesomeIcon icon={faSpinner} spin size="2xl" />
    </div>
  );
};
export default Loading;
